// This component shows the status of the form

export const FormStatusCompo = (props: {
    reportStatus: string
    lastUpdatedBy: string
    lastUpdatedOn: string
}) => {
    const { reportStatus, lastUpdatedBy, lastUpdatedOn } = props
    return (
        <div id="formStatusInfo">
            <div className="row-plugin" style={{ float: 'left', marginBottom: '10px' }}>
                <div>
                    <div>
                        Current Status:{' '}
                        <span id="formStatusLeft" style={{ fontWeight: 'bold' }}>
                            {reportStatus}
                        </span>
                    </div>
                    <div>
                        Updated By:{' '}
                        <span id="formUpdatedByLeft" style={{ fontWeight: 'bold' }}>
                            {lastUpdatedBy}
                        </span>
                    </div>
                    <div>
                        Updated On: <span id="formUpdatedOn">{lastUpdatedOn}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}
